import { useRef } from 'react';
import { TablePagination } from '@mui/material';
import type { Paginado } from '../../lib/paginacao';

/**
 * Mantém a última resposta visível enquanto a próxima página carrega — evita
 * esvaziar a tabela/paginação durante o fetch (o RTK Query zera `data` ao trocar
 * de argumento).
 */
export function useUltimaPagina<T>(data: Paginado<T> | undefined): { itens: T[]; total: number } {
  const ultima = useRef<{ itens: T[]; total: number }>({ itens: [], total: 0 });
  if (data) ultima.current = { itens: data.itens, total: data.total };
  return data ? { itens: data.itens, total: data.total } : ultima.current;
}

interface PaginacaoTabelaProps {
  total: number;
  /** 0-based (MUI). */
  pagina: number;
  tamanhoPagina: number;
  aoMudarPagina: (pagina: number) => void;
  aoMudarTamanho: (tamanho: number) => void;
}

/** Rodapé de paginação padrão (MUI TablePagination em PT-BR). */
export function PaginacaoTabela({
  total,
  pagina,
  tamanhoPagina,
  aoMudarPagina,
  aoMudarTamanho,
}: PaginacaoTabelaProps): JSX.Element | null {
  if (total === 0) return null;
  return (
    <TablePagination
      component="div"
      count={total}
      page={pagina}
      onPageChange={(_, nova) => aoMudarPagina(nova)}
      rowsPerPage={tamanhoPagina}
      onRowsPerPageChange={(e) => aoMudarTamanho(parseInt(e.target.value, 10))}
      rowsPerPageOptions={[10, 25, 50, 100]}
      labelRowsPerPage="Por página:"
      labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count}`}
    />
  );
}
